define.alias("ember-cli-string-helpers/helpers/dasherize", "media/helpers/dasherize");